<script setup>
import axios from "@/axios";
import {onMounted, ref, watch} from "vue";
import {useLanguageStore} from "@/pinia";
const props = defineProps(['isReset', 'label'])
const ages = ref([]);
const emits = defineEmits(['set_ageId'])
const s_age = ref();
const languageStore = useLanguageStore()

const getAge = ()=>{
  axios.get("/api/ages")
      .then(s=>{
        ages.value = s.data.dataList;
      }).catch(e=>console.log(e));
}


onMounted(()=>{
  getAge()
})
watch(()=>props.isReset , ()=>{
  if(props.isReset){
    s_age.value= null ;
  }
})
</script>

<template>
  <v-select
      v-model="s_age"
      @update:modelValue="emits('set_ageId', s_age)"
      :items="ages"
      item-title="ageTitle"
      item-value="ageId"
      :label="label"
      :placeholder="!label ? languageStore.get('select') : undefined"
      variant="outlined"
      density="compact"
      hide-details="auto"
      clearable
  />
</template>

<style scoped>

</style>